import { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { AccountManagementContext } from "../../../context/AccountManagementContext";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { CreateAccountRolePermission, getAccountUserUpdateRolePermission } from "../../../services/adminApiService/accountManagementApi/AccountManagementApiService";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { GoArrowLeft } from "react-icons/go";
import PageTitle from "../../../jsx/layouts/PageTitle";
export default function AccountRolePermission(accountProfileData) {

  const { id } = useParams();
  const location = useLocation();

  // Determine which role ID to use:
  // - If on role update page, use URL param id (role ID)
  // - If on user profile page, use user's assigned role ID
  const isRoleUpdatePage = location.pathname.startsWith("/account/role/update");
  const useRoleId = isRoleUpdatePage ? id : accountProfileData?.accountProfileData?.usp_role_id;

  const {
    loading,
    RolePermissionList,
    fetchAccountuserRolePermission,
    fetchRoleAccountManagementList,
    updateRolePermissionApi // ✅ your update API function from context
  } = useContext(AccountManagementContext);
  const [permissionData, setPermissionData] = useState({});
  const LOCAL_KEY = "role_permission_storage";
  const [changedPermissions, setChangedPermissions] = useState({});
  const navigate = useNavigate();

  const hideSaveButton = location.pathname.startsWith("/account/account-profile");
  const hideRoleInfoSection =
    location.pathname.startsWith("/account/role/add") ||
    location.pathname.startsWith("/account/role/update");
  const [formData, setFormData] = useState({
    role_name: "",
    description: ""
  });

const isAddRole = location.pathname.startsWith("/account/role/add");
const isUpdateRole = location.pathname.startsWith("/account/role/update");

let pageTitle = "Add Role";

if (isUpdateRole) {
  pageTitle = "Update Role";
}

  const [errors, setErrors] = useState({});
  // Handle Change
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

    // Clear error on typing
    setErrors((prev) => ({
      ...prev,
      [name]: ""
    }));
  };

  // Validation
  const validate = () => {
    let newErrors = {};

    if (!formData.role_name.trim()) {
      newErrors.role_name = "Role name is required";
    }

    return newErrors;
  };
  // ✅ Fetch API
  useEffect(() => {
    fetchAccountuserRolePermission(useRoleId);
  }, [fetchAccountuserRolePermission, useRoleId]);

  // ✅ Set Local State from API OR LocalStorage

  useEffect(() => {
    if (RolePermissionList?.data) {


      // If API gives empty → clear everything
      if (Object.keys(RolePermissionList.data).length === 0) {
        setPermissionData({});
        localStorage.removeItem(LOCAL_KEY);
        return;
      }

      // Otherwise use API data
      setPermissionData(RolePermissionList.data);

      localStorage.setItem(
        LOCAL_KEY,
        JSON.stringify(RolePermissionList.data)
      );
    }
  }, [RolePermissionList]);

  const generateSlug = (name) => {
    if (!name) return "";
    return name.toLowerCase().replace(/\s+/g, "-");
  };

  // ✅ Toggle + Store + API Payload Ready
  const handleToggle = (sectionKey, slug) => {
    setPermissionData((prev) => {
      const updatedItems = prev[sectionKey].items.map((item) => {
        if (item.slug === slug) {
          const newSelected = !item.selected;

          setChangedPermissions((prevChanged) => ({
            ...prevChanged,
            [item.id]: {
              permission_id: item?.id,
              module_id: item?.id,
              selected: newSelected,
            },
          }));

          return { ...item, selected: newSelected };
        }
        return item;
      });

      return {
        ...prev,
        [sectionKey]: {
          ...prev[sectionKey],
          items: updatedItems,
        },
      };
    });
  };

  const handleSave = async () => {
    try {

      // ✅ Get all active permissions from UI
      const permission_ids = [];

      Object.values(permissionData).forEach((section) => {
        section?.items?.forEach((item) => {
          if (item.selected) {
            permission_ids.push(item.id);
          }
        });
      });

      const payload = {
        role_name: formData.role_name,
        role_slug: generateSlug(formData.role_name),
        description: formData.description,
        permission_ids
      };

      let response;

      if (id) {
        response = await getAccountUserUpdateRolePermission(id, payload);
      } else {
        response = await CreateAccountRolePermission(payload);
      }

      if (response?.data?.status === true) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.data?.message || "Permission Updated Successfully",
          timer: 2000,
          showConfirmButton: false
        });

        setChangedPermissions({});
        navigate("/account/role");
        return;
      }

      if (response?.data?.status === "error") {
        let errorMessage = response?.data?.message;

        if (typeof errorMessage === "object") {
          errorMessage = Object.values(errorMessage).flat().join("\n");
        }

        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorMessage || "Something went wrong"
        });

        return;
      }

    } catch (error) {
      console.log("Update Error", error);

      let backendError =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Something went wrong";

      if (typeof backendError === "object") {
        backendError = Object.values(backendError).flat().join("\n");
      }

      Swal.fire({
        icon: "error",
        title: "Error",
        text: backendError
      });
    }
  };


  useEffect(() => {
    if (RolePermissionList?.data) {

      if (Object.keys(RolePermissionList.data).length === 0) {
        setPermissionData({});
        localStorage.removeItem(LOCAL_KEY);
        return;
      }

      const apiData = RolePermissionList.data;

      setPermissionData(apiData);

      // ✅ FILL FORM DATA FROM API
      setFormData({
        role_name: apiData?.role_name || "",
        description: apiData?.description || ""
      });

      localStorage.setItem(
        LOCAL_KEY,
        JSON.stringify(apiData)
      );
    }
  }, [RolePermissionList]);


  return (
    <>
      {/* <PageTitle
        activeMenu="Individual List"
        motherMenu="Manage Registration"
      /> */}
    {!hideSaveButton && <h3>{pageTitle}</h3>}
      <div className="bg-white  rounded-3">
        {!hideSaveButton && (
          <div className="p-4">
            {/* Back Button */}
            <Button
              variant=""
              className="mb-3 d-flex align-items-center gap-2 border"
              style={{ width: "fit-content" }}
              onClick={() => navigate("/account/role")}
            >
              <GoArrowLeft /> Back
            </Button>
            <Row>
              {/* Role Name */}
              <Col md={6} className="mb-3 mx-2">
                <Form.Label className="fw-semibold">
                  Role Name <span className="text-danger">*</span>
                </Form.Label>

                <Form.Control
                  type="text"
                  name="role_name"
                  placeholder="e.g. Admin"
                  value={formData.role_name}
                  onChange={handleChange}
                />

                {errors.role_name && (
                  <small className="text-danger">{errors.role_name}</small>
                )}
              </Col>

              {/* Description */}
              <Col md={12} className="mb-3 mx-2">
                <Form.Label className="fw-semibold">Description</Form.Label>

                <Form.Control
                  style={{ width: "610px" }}
                  as="textarea"
                  rows={4}
                  name="description"
                  placeholder="Write your description here..."
                  value={formData.description}
                  onChange={handleChange}
                />
              </Col>
            </Row>




          </div>
        )}
        <div className="px-3">
          {!hideRoleInfoSection && (
            <div className="mx-2 py-4">

              <div className="d-flex">
                <h4 className="mt-1">Role :</h4>
                <p className="px-2 mt-1">
                  {permissionData?.role_assigned || "N/A"}
                </p>
              </div>

              <div className="d-flex">
               <h4 style={{ minWidth: "120px" }} className="mt-1">Description :</h4>
                <p className="px-2 mt-1">
                  {permissionData?.description || "N/A"}
                </p>
              </div>

            </div>
          )}
          <h2 className="mb-4">Permissions</h2>

          {/* ✅ LOADER */}
          {loading && (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status" />
              <p className="mt-2">Loading permisstion..</p>
            </div>
          )}

          {/* ✅ NO DATA FOUND */}
          {!loading &&
            (!permissionData ||
              Object.keys(permissionData).length === 0 ||
              Object.values(permissionData).every(
                (section) => !section || !section.items || section.items.length === 0
              )) && (
              <div className="text-center py-5">
                <h5 className="text-muted">No Permissions Found</h5>
              </div>
            )}

          {/* ✅ PERMISSION LIST */}
          {!loading &&
            Object.entries(permissionData || {})
              .filter(([_, section]) => section && section.items)
              .map(([sectionKey, section]) => (
                <div key={sectionKey} className="mb-3 border p-3 rounded">
                  <h4>{section.title}</h4>

                  {section.description && (
                    <p className="text-muted">{section.description}</p>
                  )}

                  <ul className="list-unstyled">
                    {section.items?.map((item) => (
                      <li key={item.slug} className="mb-2 border rounded shadow-sm p-2 bg-white">
                        <div className="d-flex justify-content-between align-items-center">
                          <p className="mb-0">{item.name}</p>

                          <Form.Check
                            type="switch"
                            checked={item.selected}
                            readOnly={hideSaveButton}
                            style={{ pointerEvents: hideSaveButton ? "none" : "auto" }}
                            // onChange={() =>
                            //   !hideSaveButton && handleToggle(sectionKey, item.slug)
                            // }
                            onChange={(e) => {
                              if (!hideSaveButton) {
                                handleToggle(sectionKey, item.slug);
                              }
                            }}
                          />
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}

          {/* ✅ SAVE BUTTON SHOW ONLY WHEN DATA EXISTS */}
          <div className="p-3">
            {!loading &&
              permissionData &&
              Object.keys(permissionData).length > 0 &&
              !hideSaveButton && (
                <button
                  className="btn btn-primary mb-2"
                  onClick={handleSave}
                >
                  Save Permissions
                </button>
              )}
          </div>

        </div>

      </div>
    </>
  );

}


